import styled from 'styled-components/macro';
import { TABLET_BREAKPOINT } from '../../app/constants';

export const StyledSplashWrapper = styled.div`
  width: 100%;
  min-height: 207.5px;
`;

export const StyledEventInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 20px;
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    display: block;
  }
  .social-links {
    margin-top: 12px;

    @media (max-width: ${TABLET_BREAKPOINT}px) {
      text-align: center;
      margin-bottom: 20px;
    }
  }
  .link-social {
    margin-left: 1.6rem;
  }
  .mobile-live-news {
    display: none;
    @media (max-width: ${TABLET_BREAKPOINT}px) {
      display: block;
    }
  }
  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      max-width: 9.3rem;
    }
  }
  .logo-title {
    font-size: 2rem;
    font-weight: 700;
    color: ${(props) => props.theme.fontColor.primary};
    line-height: 2.6rem;
    padding: 0 1.6rem;
    max-width: 325px;
    @media (max-width: ${TABLET_BREAKPOINT}px) {
      margin: 20px 0;
      max-width: none;
      text-align: center;
    }
  }
  .loading {
    padding: 1rem 1.6rem;
    height: 20px;
    display: block;
  }
  .event-data {
    &-wrap {
      display: flex;
      @media (max-width: ${TABLET_BREAKPOINT}px) {
        display: block;
      }
    }
    &-item {
      margin-right: 50px;
      .icon {
        margin-right: 0.8rem;
        margin-left: -2.6rem;
        width: 1.8rem;
      }
      @media (max-width: 1180px) {
        margin-bottom: 20px;
      }
      @media (max-width: ${TABLET_BREAKPOINT}px) {
        width: 50%;
        margin: 0 auto 20px auto;
      }
    }
    &-col {
      @media (max-width: 1180px) {
        display: block;
      }
      @media (max-width: ${TABLET_BREAKPOINT}px) {
        display: flex;
        padding-left: 25px;
      }
      display: flex;
      align-items: start;
    }
    &-txt {
      font-size: 1.2rem;
      font-weight: 700;

      color: ${(props) => props.theme.fontColor.primary};
      &.md {
        font-size: 1.6rem;
      }
      &.grey {
        color: ${(props) => props.theme.grey.primary};
      }
      &.red {
        color: ${(props) => props.theme.red};
      }
    }
  }
`;
